import React from 'react';
import img1 from '../assets/card-gooday.png';
import img2 from '../assets/card-woohoo.png';
import img3 from '../assets/card-fuurever.png';
import img4 from '../assets/card-phd1.png';
import img5 from '../assets/card-xquic.png';
import img6 from '../assets/card-mateshine.png';
import img7 from '../assets/card-agra.png';
import img8 from '../assets/card-livia.png';
import img10 from '../assets/card-torii.png';
import img11 from '../assets/card-moonmagic.png';
import img12 from '../assets/card-realhome.png';
import img13 from '../assets/card-dino.png';
import img14 from '../assets/card-zestly.png';
import img15 from '../assets/card-tenis.png';
import img16 from '../assets/card-bbd.png';
import img17 from '../assets/card-social.png';

import portwoohoo from '../assets/interiorprojeto/MockupWoohoo.jpg';
import goodaydetail from '../assets/interiorprojeto/gooday-detail.png';
import fuureverdetail from '../assets/interiorprojeto/fuurever-details.png';
import realhomedetail from '../assets/interiorprojeto/realhome-details.png';

import mateshine1 from '../assets/videos/MateShine1.mp4';
import mateshine2 from '../assets/videos/MateShine2.mp4';
import mateshine3 from '../assets/videos/MateShine3.mp4';
import dinoeragame from '../assets/videos/dinoeragame.mp4';
import phdwebsite from '../assets/videos/phd-website.mp4';
import tenisrio from '../assets/videos/tenis-rio-sp-open.mp4';
import tenisjogar from '../assets/videos/tenis-vem-jogar.mp4';


import xquicdetail from '../assets/xquic-details.png';
import agradetail from '../assets/agra-details.png';
import moondetail from '../assets/moonmagic-details.png';
import toriidetail from '../assets/torii-details.png';
import zestlydetail from '../assets/zestly-details.png';
import bbddetail from '../assets/bbd-details.png';
import socialdetail from '../assets/social-details.png';

export const projects = [
  {
    id: 1,
    slug: 'gooday',
    categories: ['ux ui design'],
    image: img1,
    title: 'Gooday',
    subtitle: 'Mobile app design focused on experience, usability, and visual consistency.',
    description: (
      <>
        Gooday is a mobile app project developed with a strong focus on UX/UI design, usability, and product thinking. The goal was to create a visually engaging and intuitive interface, balancing functionality with a playful and modern aesthetic.
        <br />
        <a href="https://www.figma.com/proto/S322tvnhTMc225FMek2CQf/Gooday?node-id=87-854&p=f&viewport=59%2C153%2C0.13&t=v78Vu3GU6ZVqV0Gn-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=87%3A854&page-id=0%3A1" target="_blank" rel="noreferrer">
          Figma Prototype
        </a>
    
      </>
    ),
    client: 'Concept Project',
    role: 'UX/UI Design',
    tools: 'Figma, Adobe Suite',
    year: '2024',
    link: 'https://www.behance.net/gallery/213351813/Gooday',
    longImage: goodaydetail,
  },
  {
    id: 2,
    slug: 'woohoo',
    categories: ['marketing'],
    image: img2,
    title: 'Woohoo Channel',
    subtitle: 'Communication and digital design for a television channel.',
    description: (
      <>
        This project brings together creative, marketing, and digital communication work
        developed for Woohoo Channel. It includes visual strategy, branded content, and
        digital assets designed to connect with a young and engaged audience.
        <br />
        <a href="https://www.instagram.com/canalwoohoo/" target="_blank" rel="noreferrer">
          Instagram
        </a>
        <br />
        <a href="https://www.facebook.com/woohootv/" target="_blank" rel="noreferrer">
          Facebook
        </a>
        <br />
        <a href="https://woohoo.com.br/" target="_blank" rel="noreferrer">
          Website
        </a>
      </>
    ),
    client: 'Woohoo Channel',
    role: 'Graphic Design / Marketing',
    tools: 'Adobe Suite, Meta Business Suite',
    year: '2019',
    link: 'https://www.behance.net/gallery/114807509/Canal-Woohoo',
    longImage: portwoohoo,
  },
  {
    id: 3,
    slug: 'fuurever',
    categories: ['ux ui design'],
    image: img3,
    title: 'Fuurever Home',
    subtitle: 'A digital product concept with user-centered design.',
        description: (
      <>
        Fuurever Home is a digital concept project developed around the experience of finding and adopting pets. The interface was designed to feel friendly, accessible, and emotionally engaging, while maintaining clarity and ease of use.
        <br />
        <a href="https://www.figma.com/proto/8AZeoKz3MEtqdKMZWzQj9W/Fuurever-Home?node-id=1-4&p=f&viewport=635%2C254%2C0.19&t=3U1WPfDY4X21qUzG-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=1%3A4&show-proto-sidebar=1&page-id=0%3A1" target="_blank" rel="noreferrer">
          Figma Prototype
        </a>
    
      </>
    ),
    client: 'Concept Project',
    role: 'UX/UI Design',
    tools: 'Figma, Illustrator',
    year: '2025',
    link: 'https://www.behance.net/gallery/209850913/Fuurever-Home',
    longImage: fuureverdetail,
  },
  {
    id: 4,
    slug: 'phd',
    categories: ['web development'],
    image: img4,
    title: 'PHD Architects',
    subtitle:
      'A clean, modern website project combining UX/UI design and WordPress development for an architecture studio based in California.',
        description: (
      <>
        For PHD Architects, I designed and developed a responsive website focused on clean aesthetics, clear navigation, and a refined user experience. The project included UX/UI design in Figma and full implementation in WordPress using Divi, translating the studio’s visual identity into a functional and professional online presence.
        <br />
        <a href="https://phdarch.com/" target="_blank" rel="noreferrer">
          Website
        </a>
      </>
    ),

    client: 'PHD Architects',
    role: 'Web Design / Web Development',
    tools: 'WordPress, HTML, CSS, Figma',
    year: '2026',
     heroVideo: phdwebsite,
  },
  {
    id: 5,
    slug: 'xquic',
    categories: ['social media', 'graphic design', 'marketing'],
    image: img5,
    title: 'Xquic',
    subtitle: 'Multi-channel design and brand support across digital and physical touchpoints.',
    description: (
      <>
        As a designer for XQUIC, I worked across a variety of projects, including
        presentation design, event backdrops, social media content, and advertising
        campaigns. My role focused on translating the brand’s identity into consistent,
        high-impact visuals across different formats, supporting both marketing initiatives
        and live experiences.
        <br />
        <a href="https://www.linkedin.com/company/x-quic/" target="_blank" rel="noreferrer">
          LinkedIn
        </a>
        <br />
        <a href="https://xquic.com/" target="_blank" rel="noreferrer">
          Website
        </a>
      </>
    ),
    client: 'Xquic',
    role: 'Graphic Design / Marketing',
    tools: 'Photoshop, Illustrator, Canva',
    year: '2025',
    link: 'https://www.behance.net/gallery/223750177/Xquic-Social-Media',
    longImage: xquicdetail,
  },
  {
    id: 6,
    slug: 'mateshine',
    categories: ['motion design'],
    image: img6,
    title: 'Mate Shine',
    subtitle: 'Motion design and social content for a Brazilian beverage brand.',
    description:
      'I created three animated Instagram Reels for Mate Shine, a Brazilian beverage brand, focusing on dynamic visuals that highlight the product’s energy and identity. The goal was to capture attention quickly, reinforce brand presence, and create engaging, scroll-stopping content tailored for social media.',
    client: 'Mate Shine - Beverage Products',
    role: 'Motion Designer',
    tools: 'Canva',
    year: '2025',
    link: 'https://www.behance.net/gallery/138978125/Social-Media-Portfolio',
    videos: [mateshine1, mateshine2, mateshine3],
  },
  {
    id: 14,
    slug: 'tenis-brasil',
    categories: ['motion design'],
    image: img15,
    title: 'Tennis in Brazil',
    subtitle: 'Two kinetic typography videos celebrating tennis in Brazil.',
    description:
      'A motion design series about tennis in Brazil. The first video highlights the country’s biggest tournaments, Rio Open and SP Open, and the clay courts that host them. The second video invites people to pick up a racket, using the sport’s idols and fundamental strokes as hooks. Both pieces rely on bold kinetic typography, a deep green and burgundy palette inspired by tennis clubs, and rhythmic transitions that follow the pace of a rally.',
    client: 'Concept Project',
    role: 'Creative Direction / Motion Design',
    tools: 'AI-assisted motion (Claude)',
    year: '2026',
    heroVideos: [tenisrio, tenisjogar],
  },
  {
    id: 13,
    slug: 'zestly',
    categories: ['branding', 'ux ui design', 'social media'],
    image: img14,
    title: 'Zestly',
    subtitle: 'A fresh, summer-inspired brand experience for a retail analytics SaaS — designed in just 8 hours.',
    description: (
      <>
        Zestly is a SaaS platform that turns scattered retail data into clear, actionable insights.
        The brief called for a bright identity inspired by lemons and summer colors, so I built a
        vibrant palette of citrus yellows, lime greens, soft oranges, and lilac gradients, paired with
        a leaf-shaped symbol and the concept of “harvesting fresh retail intelligence.”
        <br />
        <br />
        The prototype was created in just 8 hours and includes a landing page, a 9-slide pitch
        presentation, and a set of 3 Instagram posts. The goal was to make data analytics feel
        approachable and human, with clear messaging (“No complex dashboards. No technical background
        needed.”) and a consistent visual language across web, presentation, and social media.
      </>
    ),
    client: 'Zestly - SaaS (Case Study)',
    role: 'Branding / UX/UI Design / Social Media',
    tools: 'Figma, Adobe Suite',
    year: '2026',
    longImage: zestlydetail,
  },
  {
    id: 15,
    slug: 'bbd-studios',
    categories: ['social media', 'graphic design', 'marketing'],
    image: img16,
    title: 'BBD Studios',
    subtitle: 'LinkedIn ad campaign for a South African creative and digital agency.',
    description:
      'A series of LinkedIn posts created for BBD Studios, a creative and digital marketing agency based in South Africa. Each piece promotes one of the agency’s services, such as brand development, content creation, data and CRM, and events, with short, confident headlines and a clear call to action. The visual system pairs a deep green background with lime and bold orange accents, combining people-focused photography and organic shapes to keep the campaign consistent, recognizable, and built for a professional B2B audience.',
    client: 'BBD Studios - South Africa',
    role: 'Graphic Design / Social Media',
    tools: 'Figma, Photoshop',
    year: '2026',
    longImage: bbddetail,
  },
  {
    id: 16,
    slug: 'social-media-design',
    categories: ['social media', 'graphic design'],
    image: img17,
    title: 'Social Media Design',
    subtitle: 'A selection of Instagram posts for different brands and themes.',
    description: (
      <>
        A curated selection of Instagram posts created for different brands and contexts. The
        work ranges from editorial, collage-style content with bold typography and playful
        textures to institutional campaigns for Global Her, an impact institute focused on care
        policies across the Americas, and Unna, a technology and curation company for independent
        hotels. Each set adapts its visual language to the brand while keeping a strong focus on
        storytelling, hierarchy, and scroll-stopping composition.
        <br />
        <a href="https://www.behance.net/gallery/235481083/Social-Media-Design" target="_blank" rel="noreferrer">
          Behance
        </a>
      </>
    ),
    client: 'Global Her, Unna, Editorial Content',
    role: 'Graphic Design / Social Media',
    tools: 'Photoshop, Figma, Canva',
    year: '2025',
    link: 'https://www.behance.net/gallery/235481083/Social-Media-Design',
    longImage: socialdetail,
  },
  {
    id: 7,
    slug: 'agra',
    categories: ['web development', 'branding'],
    image: img7,
    title: 'Agra Design',
    subtitle: 'A website project combining branding, design, and digital presence.',
    description: (
      <>
        Agra Design is a web project that combines branding, visual direction, and website
        execution. The project focused on creating a cohesive digital identity and
        translating brand values into an elegant and professional online experience.
        <br />
        <a href="https://www.instagram.com/agra.design_/" target="_blank" rel="noreferrer">
          Instagram
        </a>
        <br />
        <a href="https://agradesign.com.br/" target="_blank" rel="noreferrer">
          Website
        </a>
      </>
    ),
    client: 'Agra Design',
    role: 'Branding / Web Design / Web Development',
    tools: 'Adobe Suite, Figma',
    year: '2024',
    link: 'https://agradesign.com.br/',
    longImage: agradetail,
  },
  {
    id: 8,
    slug: 'torii',
    categories: ['graphic design'],
    image: img10,
    title: 'Torii Restaurant',
    subtitle: 'A curated selection of social and visual communication pieces.',
    description:
      'A portfolio selection of social media projects developed for different brands and contexts. The work highlights visual communication, consistency, and adaptability across formats, campaigns, and audiences.',
    client: 'Torii Restaurant',
    role: 'Graphic Design',
    tools: 'Adobe Suite, Figma',
    year: '2025',
    link: 'https://www.behance.net/gallery/138978125/Social-Media-Portfolio',
    longImage: toriidetail,
  },
  {
    id: 9,
    slug: 'livia-ornellas',
    categories: ['social media', "marketing"],
    image: img8,
    title: 'Livia Ornellas',
    subtitle: 'Social media marketing and content production for an interior architect.',
    description: (
      <>
        I led the social media marketing efforts, creating content strategies aligned with
        her brand and audience. I was responsible for planning and scripting posts,
        capturing photos and videos, editing the material, and managing the publishing
        process. The work focused on building a strong visual presence and engaging
        storytelling to showcase her projects and expertise.
        <br />
        <a
          href="https://www.instagram.com/liviaornellas.arq/"
          target="_blank"
          rel="noreferrer"
        >
          Instagram
        </a>
        <br />
        <a
          href="https://www.liviaornellasarquitetura.com/"
          target="_blank"
          rel="noreferrer"
        >
          Website
        </a>
      </>
    ),
    client: 'Livia Ornellas - Interior Architect',
    role: 'Graphic Design / Social Media / Video Editing',
    tools: 'Premiere, Figma, Canva, Meta Business',
    year: '2025',
    link: 'https://www.liviaornellasarquitetura.com/',
  },
  {
    id: 10,
    slug: 'realhome',
    categories: ['graphic design', "ux ui design"],
    image: img12,
    title: 'Real Home',
    subtitle: 'End-to-end design case study across digital products and brand identity.',
            description: (
      <>
        Real Home is a comprehensive design case study developed for a real estate company, where I created the visual and user experience across multiple touchpoints, including a landing page, Instagram content, branding, and a mobile app. The project focused on building a cohesive and user-centered experience, ensuring consistency between the brand identity and digital interfaces while supporting both marketing and product goals.
        <br />
        <a href="https://www.figma.com/proto/d0YxHxN1ld3F9CQ895nnPT/RealHome?node-id=46-69&p=f&viewport=749%2C-610%2C0.28&t=LAZ7IojKcH4ah7Yv-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=46%3A69&page-id=0%3A1" target="_blank" rel="noreferrer">
          Figma Prototype
        </a>
    
      </>
    ),
    client: 'Concept Project',
    role: 'UX/UI Design',
    tools: 'Figma',
    year: '2024',
    link: 'https://www.behance.net/gallery/213351813/Gooday',
    longImage: realhomedetail,
  },
  {
    id: 11,
    slug: 'moonmagic',
    categories: ["ux ui design"],
    image: img11,
    title: 'Moon Magic',
    subtitle: 'UX/UI case study for a cycle tracking app focused on Apple Watch.',
    description:
      'MoonMagic is a design case study for a menstrual cycle tracking app that connects cycle phases with the lunar cycle. The project focused on creating an intuitive and lightweight experience for Apple Watch, prioritizing clarity, quick interactions, and meaningful insights. The design translates complex biological and lunar data into simple, accessible visuals that support daily awareness and personal wellbeing.',
    client: 'Concept Project',
    role: 'UX/UI Design',
    tools: 'Figma',
    year: '2025',
    longImage: moondetail,
  },
  {
    id: 12,
    slug: 'dinoera',
    categories: ['web development'],
    image: img13,
    title: 'Dino Era',
    subtitle: 'An arcade-style web game built with HTML, CSS, and JavaScript.',
    description: (
      <>
        Dino Era is a web-based arcade game built with HTML, CSS, and JavaScript. Players
        choose one of three dinosaurs and must survive a one-minute asteroid storm. If hit
        three times, the game ends. The project focuses on gameplay logic, collision
        detection, and interactive design.
        <br />
        <a href="https://barbaraagra.github.io/Dino_Era/" target="_blank" rel="noreferrer">
          Play the Game
        </a>
      </>
    ),
    client: 'Concept Project',
    role: 'Game Developer',
    tools: 'HTML, CSS, JavaScript',
    year: '2023',
    heroVideo: dinoeragame,
  },
];